import axios from "axios";
import router from "@/router";

export const baseUrl = "https://api.arnetworks.app/api";
// export const baseUrl = "https://preview.arnetworks.app/api";
// export const baseUrl = "https://groc.khaledjamal.com/api";
// export const baseUrl = "https://cc.khaledjamal.com/api";
// export const baseUrl = "http://100.84.207.10:3001/api";

axios.interceptors.request.use(
  (config) => {
    // console.log("🚀 Axios request fired", config);

    config.baseURL = baseUrl;

    config.headers = {
      Authorization: `Bearer ${
        JSON.parse(localStorage.getItem("token")) || false
      }`,
      Accept: "application/json",
    };
    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user_info");
      router.push({ name: "login" });
    }
    return Promise.reject(error);
  }
);

export default axios;
